<template>
  <v-app class="health-report__app">
    <v-app-bar
      app
      color="#004750"
      flat
      background-color="#004750"
    >
      <v-toolbar-title class="px-4">
        <!-- hidden on md breakpoint or less -->
        <v-img
          src="./assets//human8logo.png"
          class="d-none d-md-flex"
          max-height="42"
          max-width="180"
          min-width="100"
          alt="human8"
          contain
        />
        <!-- hidden on md breakpoint or more -->
        <v-img
          src="./assets//human8logo-secondary.png"
          class="d-md-none"
          max-height="42"
          max-width="42"
          min-width="42"
          alt="human8"
          contain
        />
      </v-toolbar-title>
      <v-responsive >
        <isc-main-nav/>
      </v-responsive>
    </v-app-bar>
    <v-main>
      <v-container fluid class="pa-0">
        <bodyhead-bar />
        <global-selection ></global-selection>
      </v-container>
      <keep-alive >
        <router-view />
      </keep-alive>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',
};
</script>

<style>

  .mainApp{
    background-color: "#004750" !important;
    padding: 0% !important;
    margin-top: 64px;
  }
  .health-report__app, .health-report__app.v-application {
    background-color: #EBF0F1 !important;
    background: #EBF0F1 !important;
  }
  .health-report__dashboard {
    background-color: #EBF0F1 !important;
    background: #EBF0F1 !important;
  }
  .health-report__dashboard .v-application--wrap, .health-report__dashboard .v-sheet:not(.v-card):not(.v-alert) {
    background: #EBF0F1 !important;
    min-height: 50vh;
  }
</style>
